// Mirror Django's slugify() for ASCII headings so the section anchors returned
// by the backend match the `id` attributes we render on the Markdown headings.
//
// Django slugify(): lowercases, strips characters that aren't word chars,
// whitespace, or hyphens, then converts runs of whitespace/hyphens to a single
// hyphen, and trims leading/trailing hyphens. For ASCII headings this reduces
// to: lowercase, remove punctuation, collapse spaces/hyphens to one hyphen.
export function slugify(text) {
  return String(text)
    .toLowerCase()
    .trim()
    .normalize('NFKD')
    // strip anything that isn't a word char, space, or hyphen (mirrors Django)
    .replace(/[^\w\s-]/g, '')
    // collapse any run of whitespace/underscores/hyphens into a single hyphen
    .replace(/[\s_-]+/g, '-')
    // trim leading/trailing hyphens
    .replace(/^-+|-+$/g, '');
}

// React children -> plain string, so we can slugify rendered heading text.
export function nodeToText(children) {
  if (children == null) return '';
  if (typeof children === 'string' || typeof children === 'number') {
    return String(children);
  }
  if (Array.isArray(children)) {
    return children.map(nodeToText).join('');
  }
  if (typeof children === 'object' && children.props) {
    return nodeToText(children.props.children);
  }
  return '';
}

export default slugify;
